import { Navigate } from "react-router-dom";

import { useCurrentUser } from "@/hooks/useCurrentUser";

interface NonLegacyFounderRouteProps {
  children: React.ReactNode;
}

/**
 * Route guard that only allows access to non-legacy founders
 * Legacy founders (nonAIFounder: true) will be redirected to home
 */
const NonLegacyFounderRoute = ({ children }: NonLegacyFounderRouteProps) => {
  const { user, isLoading } = useCurrentUser();

  // Show loading state while fetching user data
  if (isLoading) {
    return <div>Loading...</div>;
  }

  // Redirect legacy founders to home
  if (user?.nonAIFounder === true) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default NonLegacyFounderRoute;
